<template>
  <div class="share-bnt-wrapper">
    <v-btn
      class="btn text1--text"
      color="light-blue accent-4"
      :loading="loading"
      :large="!icon"
      rounded
      block
      @click="shareContent()"
    >
      <v-icon :small="!icon">fa-share-nodes</v-icon>

      <span v-if="!icon" class="ml-2">
        {{ label }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShareBtn",

  data() {
    return {
      loading: false,
    };
  },

  props: {
    label: {
      type: String,
      default: "Compartilhar com meus amigos",
    },

    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },

    url: {
      type: String,
      default: "",
    },

    icon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      _user: "user",
    }),

    _url() {
      const url = this.url || this.$settings.clientURL;

      if (this._user.code) return `${url}/?code=${this._user.code}`;
      return url;
    },
  },

  methods: {
    async shareContent() {
      try {
        this.loading = true;

        if (navigator.share) {
          await navigator.share({
            title: this.title,
            text: this.description,
            url: this._url,
          });
        } else {
          navigator.clipboard.writeText(this._url);

          this.$alert("Link copiado para a área de transferência!", "info");
        }

        this.$emit("shared");
      } catch (error) {
        console.error("Erro ao compartilhar:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
